import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Alert } from '@zillow/constellation';

export const SOME_DOCUMENTS_EXPIRED_TEXT =
  'Some of the documents for this application have expired because they were uploaded more than 60 days ago. If you would like the applicant to provide latest documents, you may inform them to withdraw the application, upload latest docs, and then reapply.';
export const ALL_DOCUMENTS_EXPIRED_TEXT =
  'Documents for this application have expired because they were uploaded more than 60 days ago. If you would like the applicant to provide latest documents, you may inform them to withdraw the application, upload latest docs, and then reapply.';

const StyledAlert = styled(Alert)`
  margin-top: 12px;
  margin-bottom: 24px;
`;

export default function DocumentsExpiredAlert({ documents }) {
  const allDocsAreExpired = documents.every((document) => !document.fileName);

  return (
    <StyledAlert
      id="docs-expired-alert"
      appearance="info"
      body={allDocsAreExpired ? ALL_DOCUMENTS_EXPIRED_TEXT : SOME_DOCUMENTS_EXPIRED_TEXT}
      className={allDocsAreExpired ? 'all-docs-expired-alert__income' : 'some-docs-expired-alert__income'}
    />
  );
}

DocumentsExpiredAlert.propTypes = {
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      documentId: PropTypes.string,
      fileName: PropTypes.string,
      previewUrl: PropTypes.string,
      expiration: PropTypes.number,
    }),
  ).isRequired,
};
